import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import Menu_Lg_Bar from "./components/menu_lg_bar";
import { DummyAfterLogin } from "../../pages/CommonPublicPages/Navbars/components/DummyAfterLogin";
import "./Edash.css";

export function Edashboard() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  // Listen for collapse changes from the sidebar (desktop)
  useEffect(() => {
    const handleSidebarCollapseChange = (event) => {
      setIsCollapsed(event.detail.isCollapsed);
    };
    document.addEventListener("sidebarCollapseChange", handleSidebarCollapseChange);
    return () => {
      document.removeEventListener("sidebarCollapseChange", handleSidebarCollapseChange);
    };
  }, []);

  // Listen for mobile sidebar toggle events (from navbar)
  useEffect(() => {
    const handleToggleSidebar = (event) => {
      setIsMobileSidebarOpen(event.detail.isOpen);
    };
    document.addEventListener("toggleSidebar", handleToggleSidebar);
    return () => {
      document.removeEventListener("toggleSidebar", handleToggleSidebar);
    };
  }, []);

  const closeMobileSidebar = () => {
    const evt = new CustomEvent("toggleSidebar", { detail: { isOpen: false } });
    document.dispatchEvent(evt);
  };

  const desktopMargin = isCollapsed ? "lg:ml-20" : "lg:ml-64";

  return (
    <div className="min-h-screen bg-mainBg">
      {/* Sidebar */}
      <Menu_Lg_Bar />

      {/* Navbar - offset by sidebar width on desktop */}
      <div className={`sticky top-0 z-50 bg-white ${desktopMargin} transition-[margin] duration-300`}>
        <DummyAfterLogin />
      </div>

      {/* Mobile overlay (below navbar) */}
      {isMobileSidebarOpen && (
        <div
          className="fixed inset-0 top-14 md:top-16 lg:hidden bg-black/40 z-30"
          onClick={closeMobileSidebar}
          aria-hidden="true"
        />
      )}

      {/* Main content - offset by sidebar width on desktop */}
      <main className={`${desktopMargin} transition-[margin] duration-300 bg-mainBg`}>
        <div className="">
          <Outlet />
        </div>
      </main>
    </div>
  );
}